export default "__VITE_ASSET__BjPKl2Wy__"